<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<button-search class="pt-3" placeholder="订单编号" @search="searchEvent">
			<!-- 左边按钮 -->
			<template #left>
				<el-button type="primary" icon="el-icon-plus" size="mini" @click="navigate('djgl_ddcl_dfdd_create')">录入代付单</el-button>
			</template>
			<!-- 高级搜索 表单 -->
			<template #form>
				<el-form inline ref="form" :model="search" label-width="80px">
					<!-- 搜索内容 -->
					<el-form-item label="订单编号" class="mb-0">
						<el-input v-model="search.bh" size="mini" placeholder="订单编号"></el-input>
					</el-form-item>
					<el-form-item label="客户名" class="mb-0">
						<el-select v-model="search.kh_id" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客户简称" class="mb-0">
						<el-select v-model="search.kh_id" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form>
			</template>
		</button-search>
		<el-tabs v-model="tabIndex" @tab-click="getList">
			<el-tab-pane :key="tabI" v-for="(tab, tabI) in tabbars">
				<span slot="label" class="d-flex">
					<div style="">{{tab.name}}</div>
					<div v-if="tab.num != 0" style="background: #ffa303;width: 24px;height: 18px;border-radius: 10px;margin-top: 6px;justify-content: center;align-items: center;" class="d-flex">
						<div style="font-size: 10px;color: #fff;font-weight: 800;">{{tab.num}}</div>
					</div>
				</span>
			</el-tab-pane>
		</el-tabs>

		<el-table :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange" size="mini" key="table1" :max-height="maxHeight">
			<el-table-column align="center" prop="bh" width="100" label="订单编号" fixed="left"></el-table-column>
			<el-table-column align="center" prop="" label="客户名称" width="120" fixed="left">
				<template slot-scope="scope">
					{{scope.row.sfls == 0 ? scope.row.khdata.name : scope.row.lsname}}
				</template>
			</el-table-column>
			<el-table-column align="center" prop="j_name" label="客户名称" width="70" fixed="left">
				<template slot-scope="scope">
					{{scope.row.sfls == 0 ? scope.row.khdata.j_name : '000'}}
				</template>
			</el-table-column>
			<el-table-column prop="" align="center" width="120" label="货运方式">
				<template slot-scope="scope">
					<el-button type="success" plain size="mini">{{scope.row.hyfsdata.name}}</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="zje" align="center" width="120" label="支付金额"></el-table-column>
			<el-table-column prop="zfr" width="90" label="支付人" align="center"></el-table-column>
			<el-table-column width="120" label="联系电话" align="center">
				<template slot-scope="scope">
					{{scope.row.sfls == 0 ? scope.row.khdata.sf_phone : scope.row.lsphone}}
				</template>
			</el-table-column>
			<el-table-column prop="city" width="150" label="订单状态" align="center">
				<template slot-scope="scope">
					<div class="d-flex" style="justify-content: center;">
						<div>通知状态：</div>
						<div style="color: #ff0000;" v-if="scope.row.sftz == 0">待通知</div>
						<div style="color: #006eff;" v-else>已通知</div>
					</div>
					<div class="d-flex" style="justify-content: center;">
						<div>支付状态：</div>
						<div style="color: #ff0000;" v-if="scope.row.zf_time == ''">待付款</div>
						<div style="color: #006eff;" v-else>已支付</div>
					</div>
					<div class="d-flex" style="justify-content: center;">
						<div>待还状态：</div>
						<div style="color: #ff0000;" v-if="scope.row.dhqr == 0">待确认</div>
						<div style="color: #006eff;" v-else>已确认</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="tz_time" width="200" label="时间信息">
				<template slot-scope="scope">
					<div class="d-flex">
						<div>通知时间：</div>
						<div style="color: #ff0000;" v-if="scope.row.tz_time == ''">无</div>
						<div style="color: #006eff;" v-else>{{scope.row.tz_time}}</div>
					</div>
					<div class="d-flex">
						<div>支付时间：</div>
						<div style="color: #ff0000;" v-if="scope.row.zf_time == ''">无</div>
						<div style="color: #006eff;" v-else>{{scope.row.zf_time}}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="tz_time" width="240" label="还款信息">
				<template slot-scope="scope">
					<div class="d-flex">
						<div>确认还款日期：</div>
						<div style="color: #ff0000;" v-if="scope.row.qrhk_time == ''">无</div>
						<div style="color: #006eff;" v-else>{{scope.row.qrhk_time}}</div>
					</div>
					<div class="d-flex">
						<div>确认还款人：</div>
						<div style="color: #ff0000;" v-if="scope.row.qrhkr == ''">无</div>
						<div style="color: #006eff;" v-else>{{scope.row.qrhkr}}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="create_time" width="160" label="创建时间" align="center"></el-table-column>
			<el-table-column align="center" label="操作" fixed="right" width="180">
				<template slot-scope="scope">
					<el-button type="primary" size="mini" @click="navigate('djgl_ddcl_dfdd_create',scope.row)">编辑</el-button>
					<!-- <el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button> -->
					<el-select v-model="value" placeholder="更多" size="mini" style="width: 75px;margin-left: 10px;">
						<el-option value="1"><p @click="xxtz(scope.row)" :style="{  color: scope.row.sftz == 0 ? '#fa0000': '#0057fa' }">消息通知</p></el-option>
						<el-option value="2"><p @click="dhqr(scope.row)" :style="{  color: scope.row.dhqr == 0 ? '#fa0000': '#0057fa' }">待还确认</p></el-option>
						<el-option value="3"><p @click="qrzf(scope.row)" :style="{  color: scope.row.zfzt == 0 ? '#fa0000': '#0057fa' }">确认支付</p></el-option>
						<el-option value="9"><p @click="printData(scope.row)">打印订单</p></el-option>
					</el-select>
				</template>
			</el-table-column>
		</el-table>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		<!-- 打印模板 -->
		<div class="print-div none" id="print_area" media="print">
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 40%;"></div>
				<div style="width: 40%;font-size: 24px;">代付运费单</div>
				<div style="width: 20%;">{{dydd.hyfsdata.name}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 30%;">客户名称：{{dydd.khdata.name}}</div>
				<div style="width: 20%;">简称：{{dydd.khdata.j_name}}</div>
				<div style="width: 25%;">代付日期：{{dydd.qrhk_time}}</div>
				<div style="width: 25%;">单号：{{dydd.bh}}</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;margin-bottom: 4px;">供货方</div>
				<div style="width: 18%;display: flex;justify-content: center; align-items: center;">货物名称</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">件数</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">运费金额(元)</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">备注</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;" v-for="item in dydd.djglhw">
				<div style="width: 12%;display: flex;justify-content: center; align-items: center;margin-top: 4px;margin-bottom: 4px;">{{item.ghs}}</div>
				<div style="width: 18%;display: flex;justify-content: center; align-items: center;">{{item.hwmc}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.num}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.yf}}</div>
				<div style="width: 20%;display: flex;justify-content: center; align-items: center;">{{item.desc}}</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;margin-bottom: 4px;">
				<div style="width: 33%;">合计件数：{{dydd.hjjs}}</div>
				<div style="width: 33%;">大写：{{dydd.jedx}}</div>
				<div style="width: 33%;">合计金额：<span style="margin-right: 4px;">{{dydd.zje}}</span>元</div>
			</div>
			<div style="width: 100%;display: flex;border-bottom: 1px solid #000000;">
				<div style="width: 34%;display: flex;font-size: 13px;margin-bottom: 4px;">广州诚晖冷冻食品物流有限公司</div>
				<div style="width: 66%;display: flex;font-size: 13px;">电话：0757-85709188，85709200，85709201，17708636608</div>
			</div>
			<div style="width: 100%;display: flex;margin-top: 4px;">
				<div style="width: 33%;">制单：{{dydd.cjrdata.name}}</div>
				<div style="width: 33%;">收款人：</div>
				<div style="width: 33%;">车牌号：</div>
			</div>
		</div>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import { mapState } from 'vuex';
export default {
	mixins: [common],
	inject: ['layout'],
	components: {
		buttonSearch
	},
	data() {
		return {
			preUrl: 'dfdd',
			dydd:{
				cjrdata:{
					name:''
				},
				hyfsdata:{
					name:''
				},
				khdata:{
					name:'',
					j_name:''
				},
				qrhk_time:'',
				bh:'',
				zje:'',
				gldd:[
					{
						desc:'',
						ghf:'',
						yfje:'',
						js:0,
						hwmc:''
					}
				],
				hjjs:'',
				jedx:''
			},
			tabIndex: 0,
			tabbars: [
				{ name: '待支付', key: 'dzf' ,num:0},
				{ name: '待还确认', key: 'dhqr' ,num:0},
				{ name: '已确认', key: 'yqr' ,num:0},
				{ name: '全部', key: 'all' ,num:0}
			],
			khlist:[],
			form: {
				khxx: {
					title: '',
					content: '' 
				}
			},
			tableData: [],
			maxHeight: 0,
			multipleSelection:[],
			value:'更多',
			search: {
				bh:'',
				kh_id:''
			},
		};
	},
	// 计算属性
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user
		}),
		// 订单类型
		tab() {
			return this.tabbars[this.tabIndex].key; //拿到key值，用来高级搜索
		},
		params() {
			let str = '';
			for (let key in this.form) {
				let val = this.form[key];
				if (val) {
					str += `&${key}=${this.form[key]}`;
				}
			}
			return str;
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 296;
		});
		
		this.axios.get('/admin/khxxs', { token: true }).then(res => {
			this.khlist = res.data.data;
		});
	},
	methods: {
		getList() {
			if(this.preUrl == '') return
			this.showLoading()
			let url = this.getListUrl()
			this.axios.get(url, { // 商品规格 api
				token: true
			}).then(res => {
				let data = res.data.data
				this.page.total = data.totalCount // 获取分页信息				
				this.getListResult(data) // 获取到的数据储存到getListResult(data)，方便外面调用修改
				this.hideLoading()
			}).catch(err => {
				this.hideLoading()
			})
		},
		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&tab=${this.tab}&kh_id=${this.search.kh_id}&bh=${this.search.bh}`;
		},
		// 获取列表 可修改
		getListResult(e) {
			this.tableData = e.list
			this.tabbars[0].num = e.dzf
			this.tabbars[1].num = e.dhqr
			this.tabbars[2].num = e.yqr
			console.log(this.tabbars)
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 鼠标单击的事件
		navigate(name, e) {
			console.log(e)
			// 初始化表单
			if (!e) {
				var data = {
					id:0,
					kh_id:'',
					bh:'自动生成',
					hyfs:'',
					zje:0,
					zfr:'',
					qrhk_time:'',
					qrhkr:'',
					desc:'',
					zfzt:0,
					cjr: this.user.id,
					zf_time:'',
					sftz:0,
					tz_time:'',
					sfls:0,
					lsname:'',
					lsphone:'',
					dhqr:0,
					djglhw:[]
				};
			} else {
				var data = {
					id:e.id,
					kh_id:e.kh_id,
					bh:e.bh,
					hyfs:e.hyfs,
					zje:e.zje,
					zfr:e.zfr,
					qrhk_time:e.qrhk_time,
					qrhkr:e.qrhkr,
					desc:e.desc,
					zfzt:e.zfzt,
					cjr: this.user.id,
					zf_time:e.zf_time,
					sftz:e.sftz,
					tz_time:e.tz_time,
					sfls:e.sfls == 0 ? false : true,
					lsname:e.lsname,
					lsphone:e.lsphone,
					dhqr:e.dhqr,
					djglhw:e.djglhw
					
				};
			}
			this.$router.push({
				name,
				params: { data }
			});
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.search.bh = e
				this.getList()
				return
			}
			// 高级搜索
			this.getList()
		},
		// 清空筛选条件
		clearSearch() {
			this.search = {
				bh: "",
				kh_id:'',
			}
		},
		printData(e){
			this.dydd = e
			this.dydd.hjjs = 0
			for(let i of this.dydd.djglhw){
				this.dydd.hjjs += i.num
			}
			this.dydd.jedx = this.moneyToCaptital(e.zje)
			console.log(this.dydd)
			setTimeout(()=> {
				const style = '@page {  } ' +'@media print { .print-div{ padding:8px;background-color:#cccccc; }' ;
				printJS({
					printable: 'print_area',
					type: 'html',
					style: style,// 亦可使用引入的外部css;
					scanStyles: false
				})
				this.value = '更多'
			}, 1000);
		},
		xxtz(e){
			this.axios.get('/admin/dj/xxtz/'+e.id, { token: true }).then(res => {
				this.$message({
					type: 'success',
					message: '通知成功'
				});
				this.value = '更多'
				this.getList()
			});
		},
		dhqr(e){
			this.axios.get('/admin/dj/dhqr/'+e.id, { token: true }).then(res => {
				this.$message({
					type: 'success',
					message: '确认完成'
				});
				this.value = '更多'
				this.getList()
			});
		},
		qrzf(e){
			this.axios.get('/admin/dj/zfqr/'+e.id, { token: true }).then(res => {
				this.$message({
					type: 'success',
					message: '确认支付'
				});
				this.value = '更多'
				this.getList()
			});
		},
		// 大小写转换
		moneyToCaptital(money) {
				//将小数点前后划分开
		        const dots=money.split('.')
		        const dotFor=dots[0]
		        const dotBehind=dots[1]
		        //小数点前一部分，先反转一下，如'123'变成‘321’
		        money = dotFor.split('').reverse().join('')
		        const cap = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖")
		        const unit = new Array("", "拾", "佰", "仟")
		        const lunit = new Array("", "万", "亿", "兆")
		        const len = money.length
		        const level = Math.ceil(len / 4)
		        let res = ''
		        //每4位数作为一次计算，如'1234444'读作一百二十三万四千四百四十四，反转后变为4444,321，从后开始往前计算
		        for (let i = level - 1; i >= 0; --i) {
		            let hasZero = false//用一个hasZero变量控制0的读法
		            for (let k = 3; k >= 0; --k) {
		                let cur = +i * 4 + k
		                if (cur < len) {
		                	//如果0在中间或前面，读出来，如果在后面不读出来
		                	//如果有多个0在前面或中间，只读一个
		                    if (money[cur] == '0') hasZero = true//遇到0先不读出
		                    else {//遇到0之后的第一个非0数字证明0在中间位置，需要读出来
		                        if (hasZero) {
		                            res += '零'
		                        }
		                        res += cap[+money[cur]] + ''
		                        res += unit[cur % 4] + ''
		                    }
		                }
		            }
		            res += lunit[i]
		        }
		        res+='元'
		        //小数点后面，只考虑两位数角和分
		        if(dotBehind){
		            const dot0=dotBehind[0]
		            const dot1=dotBehind[1]
		            if(dot0=='0'){
		                if(dot1&&dot1!='0') res+=cap[+dot0]+'角'+cap[+dot1]+'分'
		                else res+=cap[+dot0]+'角'
		            }else{
		                if(dot1&&dot1!='0') res+='零角'+cap[+dot1]+'分'
		            }
		        }
		       
		        console.log('res', res)
		        return res
		    }

	}
};
</script>

<style>
.el-collapse-item__header {
	/* display: flex; */
	align-items: center;
	height: 48px;
	line-height: 48px;
	margin-left: 10px;
	cursor: pointer;
	font-size: 13px;
	/* font-weight: 500; */
	transition: border-bottom-color 0.3s;
	outline: 0;
}
.demo-table-expand {
	font-size: 0;
}
.demo-table-expand label {
	width: 90px;
	color: #99a9bf;
}
.demo-table-expand .el-form-item {
	margin-right: 0;
	margin-bottom: 0;
	width: 50%;
}
.el-dropdown-link {
	cursor: pointer;
	color: #ff8c00;
}
.el-icon-arrow-down {
	font-size: 12px;
}
</style>
